import { render } from "./TheResults.vue?vue&type=template&id=327fb6c3&scoped=true&lang=html"
import script from "./TheResults.vue?vue&type=script&lang=js"
export * from "./TheResults.vue?vue&type=script&lang=js"

import "./TheResults.vue?vue&type=style&index=0&id=327fb6c3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327fb6c3"]])

export default __exports__